import { t } from 'i18next'
import { z } from 'zod'

import { PersonaInfoSummary } from '@/modules/shared/schemas/PersonaInfoSummary'

export const TicketEvaluationModalData = z.object({
  ticketNumber: z.number(),
  ticketDescription: z.string(),
  attendant: PersonaInfoSummary,
  patient: PersonaInfoSummary.nullable()
})

export type TicketEvaluationModalData = z.infer<
  typeof TicketEvaluationModalData
>

export const TicketEvaluation = z.object({
  id: z.string(),
  evaluation: z.number(),
  description: z.string().nullable()
})
export type TicketEvaluation = z.infer<typeof TicketEvaluation>

export const CreateTicketEvaluationsDTO = z.object({
  description: z.string().nullable(),
  evaluation: z
    .number()
    .min(1, t('general.form.minValue', { value: 1 }))
    .max(5, t('general.form.maxValue', { value: 5 }))
})

export type CreateTicketEvaluationsDTO = z.infer<
  typeof CreateTicketEvaluationsDTO
>
